import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            welcome: "Welcome to CAPIVIO the co-investment Platform",
            home: {
                slogan: "INVEST SMART. LIVE FREE.",
                login: "Login",
                signup: "Sign Up",
            },
            login: "Login",
            signup: "Sign Up",
            dashboard: "Dashboard",
            backToHome: "Back to Home",
            balance: "Your Balance",
            addMoney: "Add Money",
            sendMessage: "Send a Message",
            recentMessages: "Recent Messages",
            investNow: "Invest Now",
            learnMore: "Learn More",
            signInWithGoogle: "Sign In with Google",
            signInWithMicrosoft: "Sign In with Microsoft",
            email: "Email",
            password: "Password",
            signIn: "Sign In",
            signOut: "Sign Out",
            user: "User",
            none: "None",
            emailNotVerified: "Email not verified",
            emailVerified: "Email verified",
            firstNameRequired: "First Name (required)",
            lastName1Required: "Last Name 1 (required)",
            lastName2Optional: "Last Name 2 (optional)",
            confirmPassword: "Confirm Password",
            confirmPasswordRequired: "Confirm Password is required",
            passwordsDoNotMatch: "Passwords do not match",
            creatingAccount: "Creating Account...",
            googleSignInError: "Error signing in with Google",
            microsoftSignInError: "Error signing in with Microsoft",
            googleSignUpError: "Error signing up with Google",
            microsoftSignUpError: "Error signing up with Microsoft",
            alreadyHaveAccount: "Already have an account?",
            signupError: "Error signing up",
            loginError: "Error logging in",
            resetPassword: "Reset Password",
            sending: "Sending...",
            rememberPassword: "Remember your password?",
            invalidEmail: "Invalid email address",
            emailRequired: "Email is required",
            passwordRequired: "Password is required",
            passwordMinLength: "Password must be at least 6 characters",
            addMessage: "Add Message",
            fetchMessages: "Fetch Messages",
            storage: "Storage",
            uploadFile: "Upload File",
            viewUploadedFile: "View Uploaded File",
            cloudFunction: "Cloud Function",
            callHelloWorld: "Call helloWorld Function",
            result: "Result",
            platformName: "CAPIVIO",
            welcomeDashboard: "Welcome to Your Dashboard",
            dashboardDescription: "Manage your investments and track your portfolio here.",
            enterValidAmount: "Please enter a valid amount.",
            balanceUpdated: "Balance updated!",
            balanceUpdateError: "Error updating balance.",
            msgStatus: "Message status",
            unknownUser: "Unknown User",
            decryptionFailed: "[Decryption failed]",
            decryptionError: "[Decryption error]",
            viewCollections: "View Firestore Collections",
            promoteUserToAdmin: "Promote User to Admin",
            userNotFound: "User not found.",
            userPromoted: "User promoted to admin!",
            promoteError: "Error:",
            investmentOverview: "Investment Overview",
            noInvestmentHistory: "No investment history yet.",
            on: "on",
            recentActivity: "Recent Activity",
            noRecentActivity: "No recent activity.",
            availableOpportunities: "Available Investment Opportunities",
            loadingOpportunities: "Loading opportunities...",
            min: "min",
            return: "return",
            months: "months",
            totalAmount: "Total Amount",
            noOpportunities: "No investment opportunities available at the moment.",
            fetchCollectionsError: "Error fetching collections:",
            firestoreCollections: "Firestore Collections",
            loading: "Loading...",
            noDocumentsFound: "No documents found.",
            signingIn: "Signing In...",
            signUpWithGoogle: "Sign Up with Google",
            signUpWithMicrosoft: "Sign Up with Microsoft",
            userEmail: "User Email",
            promote: "Promote",
            initializeSampleData: "Initialize Sample Data",
            firebaseDemoPage: "Firebase Demo Page",
            signInEmailPassword: "Sign In email password",
            resetPasswordError: "Error resetting password.",
            checkEmailForReset: "Check your email for reset instructions.",
            agents: {
                manageButton: "Agent Management",
                avgScore: "Average Score",
                name: "Name",
                feedbackCount: "Feedback Count",
                backToAdmin: "Back to Admin Panel",
                title: "Agent Management",
                listTitle: "Agent List",
                noAgents: "No agents to display.",
                type: "Type",
                user: "User",
                active: "Active",
                achievements: "Achievements",
                select: "Select",
                yes: "Yes",
                no: "No",
                view: "View",
                exportCSV: "Export Agent Ranking CSV",
                exportPDF: "Export PDF",
                createTestAgents: "Create Test Agents",
                creating: "Creating...",
                viewDetails: "View agent details and performance",
                editAgent: "Edit agent information",
                blockAgent: "Block or deactivate agent",
                rankingTitle: "Agent Ranking",
                detailTitle: "Agent Details",
                tier: "Tier",
                associatedOpportunities: "Associated Opportunities",
                operations: "Operations",
                opportunity: "Opportunity",
                amount: "Amount",
                date: "Date",
                status: "Status",
                score: "Score",
                feedback: "Feedback",
                fullProfile: "Full Agent Profile",
                recentNotifications: "Recent Notifications",
                close: "Close",
                opportunities: "Opportunities",
                commissions: "Commissions",
                actions: "Actions",
                all: "All",
            },
            admin: {
                goToAdminPanel: "Admin Panel",
                title: "Title",
                agent: "Agent",
                amount: "Amount",
                date: "Date",
                actions: "Actions",
                viewAgent: "View Agent",
                approve: "Approve",
                reject: "Reject",
                agentDetails: "Agent Details",
                close: "Close",
                rejectOpportunity: "Reject Opportunity",
                rejectReason: "Reason for rejection",
                cancel: "Cancel",
                opportunityApproved: "Opportunity approved.",
                errorApproving: "Error approving opportunity.",
                opportunityRejected: "Opportunity rejected.",
                errorRejecting: "Error rejecting opportunity.",
                noPendingOpportunities: "No pending opportunities.",
                strategy: {
                    title: "Strategy Management",
                    subtitle: "Manage, edit, and view investment strategies available on the platform.",
                    statsTitle: "Strategy Statistics",
                    opportunityCount: "Opportunities",
                    uniqueInvestors: "Unique Investors",
                    totalCapital: "Total Capital",
                    averageReturn: "Average Return",
                    completionRate: "Completion Rate"
                }
            },
            strategies: {
                guideTitle: "Investment Strategies Guide",
                guideDescription: "Discover CAPIVIO's 12 real estate investment strategies. Choose the one that best fits your profile and goals.",
                cta: "Sign up and start investing",
                category: "Category",
                difficulty: "Difficulty",
                riskLevel: "Risk Level",
                code: "Code",
                label: "Label",
                description: "Description",
                icon: "Icon",
                color: "Color",
                crv: {
                    label: "Fix & Flip",
                    description: "Buy, renovate, and sell property in central areas",
                    category: "Renovation",
                    difficulty: "Intermediate",
                    riskLevel: "Medium"
                },
                cra: {
                    label: "Fix & Rent",
                    description: "Rental income + asset appreciation",
                    category: "Renovation",
                    difficulty: "Intermediate",
                    riskLevel: "Low-Medium"
                },
                cv: {
                    label: "Buy & Sell",
                    description: "Arbitrage or natural appreciation",
                    category: "Trading",
                    difficulty: "Basic",
                    riskLevel: "Medium"
                },
                ca: {
                    label: "Stable Rental",
                    description: "Stable portfolio with rental income",
                    category: "Rental",
                    difficulty: "Basic",
                    riskLevel: "Low"
                },
                ter: {
                    label: "Land Development",
                    description: "Purchase of developable land for resale or development",
                    category: "Development",
                    difficulty: "Advanced",
                    riskLevel: "High"
                },
                dev: {
                    label: "New Development",
                    description: "Investment in full-scale development",
                    category: "Development",
                    difficulty: "Advanced",
                    riskLevel: "High"
                },
                ll: {
                    label: "Turnkey",
                    description: "Already developed project, only requires final investment",
                    category: "Trading",
                    difficulty: "Basic",
                    riskLevel: "Medium"
                },
                rr: {
                    label: "Rental Rehabilitation",
                    description: "Minimal adaptation project for immediate rental",
                    category: "Renovation",
                    difficulty: "Intermediate",
                    riskLevel: "Low-Medium"
                },
                cov: {
                    label: "Coliving / Coworking",
                    description: "Investment in shared assets with focus on flexible rental",
                    category: "Alternative",
                    difficulty: "Advanced",
                    riskLevel: "Medium-High"
                },
                mfh: {
                    label: "Multi-Family Housing",
                    description: "Investment in complete buildings for residential rental",
                    category: "Rental",
                    difficulty: "Intermediate",
                    riskLevel: "Low-Medium"
                },
                com: {
                    label: "Commercial / Retail",
                    description: "Stores, warehouses, offices, shopping centers",
                    category: "Commercial",
                    difficulty: "Advanced",
                    riskLevel: "Medium-High"
                },
                alt: {
                    label: "Alternative Assets",
                    description: "Non-traditional investments: senior living, hospitality, tourism",
                    category: "Alternative",
                    difficulty: "Advanced",
                    riskLevel: "High"
                }
            },
            header: { dashboard: "Dashboard", logout: "Logout" },
            menu: {
                dashboard: "Dashboard",
                opportunities: "Opportunities",
                investments: "My Investments",
                portfolio: "Portfolio",
                kyc: "KYC Verification",
                financialVerification: "Financial Verification",
                offboarding: "Offboarding",
                adminPanel: "Admin Panel",
                kycManagement: "KYC Management",
                offboardingManagement: "Offboarding Management",
                agentes: "Agents",
                collections: "Collections",
                logout: "Logout",
                main: "Main",
                tools: "Tools",
                admin: "Admin",
                preferences: "Preferences",
                messages: "Messages",
            },
            profile: {
                title: "My Profile",
                identity: "Identity & Account",
                investmentProfile: "Investment Profile",
                compliance: "Compliance & Security",
                preferences: "Preferences",
                name: "Name",
                email: "Email",
                phone: "Phone",
                kycStatus: "KYC Status",
                kycButton: "Submit/Update KYC",
                role: "Role",
                createdAt: "Account Created At",
                lastLogin: "Last Login",
                notAvailable: "Not available",
                portfolioValue: "Portfolio Value",
                numInvestments: "Number of Investments",
                riskLevel: "Preferred Risk Level",
                lastInvestment: "Last Investment Date",
                topOpportunities: "Top 3 Invested Opportunities",
                downloadData: "Download My Data (GDPR)",
                loginHistory: "Login History",
                language: "Language Preference",
                darkMode: "Dark Mode",
                notifications: "Notification Preferences",
                emailAlerts: "Email alerts (opportunity updates)",
                investmentUpdates: "Investment status updates",
                monthlySummary: "Monthly portfolio summary",
                consent: "Consent for Communications",
                consentSaved: "Consent updated successfully!",
                consentError: "Failed to update consent.",
                opportunityName: "Opportunity Name",
                opportunityCode: "Opportunity Code",
                investedAmount: "Invested Amount",
                expectedReturn: "Expected Return (%)",
                estimatedReturn: "Estimated Return",
                exportFileName: "my_opportunities",
            },
            opportunity: {
                title: "Title",
                description: "Description",
                propertyType: "Property Type",
                location: "Location",
                totalBudget: "Total Budget (€)",
                expectedReturn: "Expected Return (%)",
                executionTime: "Execution Time (months)",
                minimumInvestment: "Minimum Investment (€)",
                projectImages: "Project Images",
                uploadImages: "Upload Images",
                legalDocumentation: "Legal Documentation",
                uploadDocuments: "Upload Documents",
                minCharacters: "minimum characters",
                minBudget: "Minimum €100,000",
                returnRange: "Between 5% and 50%",
                executionRange: "Between 6 and 120 months",
                submittedForApproval: "Opportunity submitted for approval",
                creationError: "Error creating opportunity",
                editProject: "Edit Project",
                createNewProject: "Create New Project",
                createProject: "Create Project",
            },
            common: {
                cancel: "Cancel",
                back: "Back",
                next: "Next",
                processing: "Processing...",
                update: "Update",
            },
        },
    },
    es: {
        translation: {
            welcome: "Bienvenido a CAPIVIO, la plataforma de coinversión",
            home: {
                slogan: "INVIERTE INTELIGENTE. VIVE LIBRE.",
                login: "Iniciar sesión",
                signup: "Regístrate"
            },
            login: "Iniciar sesión",
            signup: "Registrarse",
            dashboard: "Panel",
            backToHome: "Volver a inicio",
            balance: "Tu saldo",
            addMoney: "Ingresar",
            sendMessage: "Enviar un mensaje",
            recentMessages: "Mensajes recientes",
            investNow: "Invertir ahora",
            learnMore: "Saber más",
            signInWithGoogle: "Iniciar sesión con Google",
            signInWithMicrosoft: "Iniciar sesión con Microsoft",
            email: "Correo electrónico",
            password: "Contraseña",
            signIn: "Iniciar sesión",
            signOut: "Cerrar sesión",
            user: "Usuario",
            none: "Ninguno",
            emailNotVerified: "Correo electrónico no verificado",
            emailVerified: "Correo electrónico verificado",
            firstNameRequired: "Nombre (requerido)",
            lastName1Required: "Apellido 1 (requerido)",
            lastName2Optional: "Apellido 2 (opcional)",
            confirmPassword: "Confirmar contraseña",
            confirmPasswordRequired: "Se requiere confirmar la contraseña",
            passwordsDoNotMatch: "Las contraseñas no coinciden",
            creatingAccount: "Creando cuenta...",
            googleSignInError: "Error al iniciar sesión con Google",
            microsoftSignInError: "Error al iniciar sesión con Microsoft",
            googleSignUpError: "Error al registrarse con Google",
            microsoftSignUpError: "Error al registrarse con Microsoft",
            alreadyHaveAccount: "¿Ya tienes una cuenta?",
            signupError: "Error al registrarse",
            loginError: "Error al iniciar sesión",
            resetPassword: "Restablecer contraseña",
            sending: "Enviando...",
            rememberPassword: "¿Recuerdas tu contraseña?",
            invalidEmail: "Correo electrónico inválido",
            emailRequired: "Se requiere correo electrónico",
            passwordRequired: "Se requiere contraseña",
            passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
            addMessage: "Agregar mensaje",
            fetchMessages: "Recuperar mensajes",
            storage: "Almacenamiento",
            uploadFile: "Cargar archivo",
            viewUploadedFile: "Ver archivo cargado",
            cloudFunction: "Función en la nube",
            callHelloWorld: "Llamar a la función helloWorld",
            result: "Resultado",
            platformName: "CAPIVIO",
            welcomeDashboard: "Bienvenido a su panel",
            dashboardDescription: "Administre sus inversiones y rastree su cartera aquí.",
            enterValidAmount: "Por favor, ingrese una cantidad válida.",
            balanceUpdated: "Saldo actualizado!",
            balanceUpdateError: "Error al actualizar el saldo.",
            msgStatus: "Estado del mensaje",
            unknownUser: "Usuario desconocido",
            decryptionFailed: "[Desencriptación fallida]",
            decryptionError: "[Error de desencriptación]",
            viewCollections: "Ver colecciones de Firestore",
            promoteUserToAdmin: "Promover usuario a administrador",
            userNotFound: "Usuario no encontrado.",
            userPromoted: "Usuario promovido a administrador!",
            promoteError: "Error:",
            investmentOverview: "Resumen de inversión",
            noInvestmentHistory: "Aún no hay historial de inversión.",
            on: "en",
            recentActivity: "Actividad reciente",
            noRecentActivity: "No hay actividad reciente.",
            availableOpportunities: "Oportunidades de inversión disponibles",
            loadingOpportunities: "Cargando oportunidades...",
            min: "min",
            return: "devolver",
            months: "meses",
            totalAmount: "Monto total",
            noOpportunities: "No hay oportunidades de inversión disponibles en este momento.",
            fetchCollectionsError: "Error al recuperar colecciones:",
            firestoreCollections: "Colecciones de Firestore",
            loading: "Cargando...",
            noDocumentsFound: "No se encontraron documentos.",
            signingIn: "Iniciando sesión...",
            signUpWithGoogle: "Registrarse con Google",
            signUpWithMicrosoft: "Registrarse con Microsoft",
            userEmail: "Correo electrónico del usuario",
            promote: "Promover",
            initializeSampleData: "Inicializar datos de muestra",
            firebaseDemoPage: "Página de demostración de Firebase",
            signInEmailPassword: "Iniciar sesión con correo y contraseña",
            resetPasswordError: "Error al restablecer la contraseña.",
            checkEmailForReset: "Revisa tu correo para instrucciones de restablecimiento.",
            agents: {
                manageButton: "Gestión de Agentes (Captadores)",
                avgScore: "Puntuación media",
                name: "Nombre",
                feedbackCount: "Puntuaciones",
                backToAdmin: "Volver al Panel de Administración",
                title: "Gestión de Agentes (Captadores)",
                listTitle: "Listado de Agentes",
                noAgents: "No hay agentes para mostrar.",
                type: "Tipo",
                user: "Usuario",
                active: "Activo",
                achievements: "Logros",
                select: "Seleccionar",
                yes: "Sí",
                no: "No",
                view: "Ver",
                exportCSV: "Exportar Ranking CSV",
                exportPDF: "Exportar PDF",
                createTestAgents: "Crear Agentes de Prueba",
                creating: "Creando...",
                viewDetails: "Ver detalles del agente y su rendimiento",
                editAgent: "Editar información del agente",
                blockAgent: "Bloquear o desactivar agente",
                rankingTitle: "Ranking de Agentes",
                detailTitle: "Detalle de Agente",
                tier: "Tier",
                associatedOpportunities: "Oportunidades Asociadas",
                operations: "Operaciones",
                opportunity: "Oportunidad",
                amount: "Monto",
                date: "Fecha",
                status: "Estado",
                score: "Puntuación",
                feedback: "Feedback",
                fullProfile: "Perfil Completo del Agente",
                recentNotifications: "Notificaciones recientes",
                close: "Cerrar",
                opportunities: "Oportunidades",
                commissions: "Comisiones",
                actions: "Acciones",
                all: "Todas",
            },
            admin: {
                goToAdminPanel: "Panel de Administración",
                title: "Título",
                agent: "Agente",
                amount: "Monto",
                date: "Fecha",
                actions: "Acciones",
                viewAgent: "Ver Agente",
                approve: "Aprobar",
                reject: "Rechazar",
                agentDetails: "Detalles del Agente",
                close: "Cerrar",
                rejectOpportunity: "Rechazar Oportunidad",
                rejectReason: "Motivo del rechazo",
                cancel: "Cancelar",
                opportunityApproved: "Oportunidad aprobada.",
                errorApproving: "Error al aprobar la oportunidad.",
                opportunityRejected: "Oportunidad rechazada.",
                errorRejecting: "Error al rechazar la oportunidad.",
                noPendingOpportunities: "No hay oportunidades pendientes.",
                strategy: {
                    title: "Gestión de Estrategias",
                    subtitle: "Administra, edita y visualiza las estrategias de inversión disponibles en la plataforma.",
                    statsTitle: "Estadísticas por Estrategia",
                    opportunityCount: "Oportunidades",
                    uniqueInvestors: "Inversores únicos",
                    totalCapital: "Capital total",
                    averageReturn: "Retorno medio",
                    completionRate: "Tasa de finalización"
                }
            },
            strategies: {
                guideTitle: "Guía de Estrategias de Inversión",
                guideDescription: "Descubre las 12 estrategias de inversión inmobiliaria de CAPIVIO. Elige la que mejor se adapte a tu perfil y objetivos.",
                cta: "Regístrate y comienza a invertir",
                category: "Categoría",
                difficulty: "Dificultad",
                riskLevel: "Nivel de riesgo",
                code: "Código",
                label: "Etiqueta",
                description: "Descripción",
                icon: "Icono",
                color: "Color",
                crv: {
                    label: "Reformar y Vender",
                    description: "Compra, reforma y venta de vivienda en zona céntrica",
                    category: "Renovación",
                    difficulty: "Intermedio",
                    riskLevel: "Medio"
                },
                cra: {
                    label: "Reformar y Alquilar",
                    description: "Ingresos por rentas + revalorización de activo",
                    category: "Renovación",
                    difficulty: "Intermedio",
                    riskLevel: "Bajo-Medio"
                },
                cv: {
                    label: "Comprar y Vender",
                    description: "Arbitraje o revalorización natural",
                    category: "Trading",
                    difficulty: "Básico",
                    riskLevel: "Medio"
                },
                ca: {
                    label: "Alquiler Estable",
                    description: "Patrimonial estable con ingresos por renta",
                    category: "Renta",
                    difficulty: "Básico",
                    riskLevel: "Bajo"
                },
                ter: {
                    label: "Promoción de Terreno",
                    description: "Compra de terreno urbanizable para reventa o desarrollo",
                    category: "Desarrollo",
                    difficulty: "Avanzado",
                    riskLevel: "Alto"
                },
                dev: {
                    label: "Obra Nueva",
                    description: "Inversión en promoción integral",
                    category: "Desarrollo",
                    difficulty: "Avanzado",
                    riskLevel: "Alto"
                },
                ll: {
                    label: "Llave en Mano",
                    description: "Proyecto ya desarrollado, solo requiere inversión final",
                    category: "Trading",
                    difficulty: "Básico",
                    riskLevel: "Medio"
                },
                rr: {
                    label: "Rehabilitación Rental",
                    description: "Proyecto de adecuación mínima para alquiler inmediato",
                    category: "Renovación",
                    difficulty: "Intermedio",
                    riskLevel: "Bajo-Medio"
                },
                cov: {
                    label: "Coliving / Coworking",
                    description: "Inversión en activos compartidos con enfoque en renta flexible",
                    category: "Alternativo",
                    difficulty: "Avanzado",
                    riskLevel: "Medio-Alto"
                },
                mfh: {
                    label: "Multi-Family Housing",
                    description: "Inversión en edificios completos para alquiler residencial",
                    category: "Renta",
                    difficulty: "Intermedio",
                    riskLevel: "Bajo-Medio"
                },
                com: {
                    label: "Comercial / Retail",
                    description: "Locales, naves, oficinas, centros comerciales",
                    category: "Comercial",
                    difficulty: "Avanzado",
                    riskLevel: "Medio-Alto"
                },
                alt: {
                    label: "Activos Alternativos",
                    description: "Inversiones no tradicionales: senior living, hotelero, turístico",
                    category: "Alternativo",
                    difficulty: "Avanzado",
                    riskLevel: "Alto"
                }
            },
            header: { dashboard: "Panel", logout: "Cerrar sesión" },
            menu: {
                dashboard: "Panel",
                opportunities: "Oportunidades",
                investments: "Mis Inversiones",
                portfolio: "Portafolio",
                kyc: "Verificación KYC",
                financialVerification: "Verificación Financiera",
                offboarding: "Desboarding",
                adminPanel: "Panel de Administración",
                kycManagement: "Gestión KYC",
                offboardingManagement: "Gestión Desboarding",
                agentes: "Agentes",
                collections: "Colecciones",
                logout: "Cerrar sesión",
                main: "Principal",
                tools: "Herramientas",
                admin: "Administrador",
                preferences: "Preferencias",
                messages: "Mensajes",
            },
            profile: {
                title: "Mi Perfil",
                identity: "Identidad y Cuenta",
                investmentProfile: "Perfil de Inversión",
                compliance: "Cumplimiento Normativo y Seguridad",
                preferences: "Preferencias",
                name: "Nombre",
                email: "Correo electrónico",
                phone: "Teléfono",
                kycStatus: "Estado KYC",
                kycButton: "Enviar/Actualizar KYC",
                role: "Rol",
                createdAt: "Cuenta creada el",
                lastLogin: "Último acceso",
                notAvailable: "No disponible",
                portfolioValue: "Valor del portafolio",
                numInvestments: "Número de inversiones",
                riskLevel: "Nivel de riesgo preferido",
                lastInvestment: "Última inversión",
                topOpportunities: "Top 3 Oportunidades Invertidas",
                downloadData: "Descargar mis datos (GDPR)",
                loginHistory: "Historial de inicio de sesión",
                language: "Idioma preferido",
                darkMode: "Modo oscuro",
                notifications: "Preferencias de notificación",
                emailAlerts: "Alertas por email (actualizaciones de oportunidades)",
                investmentUpdates: "Actualizaciones de estado de inversión",
                monthlySummary: "Resumen mensual de portafolio",
                consent: "Consentimiento para comunicaciones",
                consentSaved: "¡Consentimiento actualizado correctamente!",
                consentError: "Error al actualizar el consentimiento.",
                opportunityName: "Nombre de la Oportunidad",
                opportunityCode: "Código de Oportunidad",
                investedAmount: "Cantidad Invertida",
                expectedReturn: "Porcentaje Esperado",
                estimatedReturn: "Retorno Estimado",
                exportFileName: "mis_oportunidades",
            },
            opportunity: {
                title: "Título",
                description: "Descripción",
                propertyType: "Tipo de Propiedad",
                location: "Ubicación",
                totalBudget: "Presupuesto Total (€)",
                expectedReturn: "Rentabilidad Esperada (%)",
                executionTime: "Plazo de Ejecución (meses)",
                minimumInvestment: "Inversión Mínima (€)",
                projectImages: "Imágenes del Proyecto",
                uploadImages: "Subir Imágenes",
                legalDocumentation: "Documentación Legal",
                uploadDocuments: "Subir Documentos",
                minCharacters: "caracteres mínimos",
                minBudget: "Mínimo €100,000",
                returnRange: "Entre 5% y 50%",
                executionRange: "Entre 6 y 120 meses",
                submittedForApproval: "Oportunidad enviada para aprobación",
                creationError: "Error al crear la oportunidad",
                editProject: "Editar Proyecto",
                createNewProject: "Crear Nuevo Proyecto",
                createProject: "Crear Proyecto",
            },
            common: {
                cancel: "Cancelar",
                back: "Atrás",
                next: "Siguiente",
                processing: "Procesando...",
                update: "Actualizar",
            },
        },
    },
    ca: {
        translation: {
            welcome: "Benvingut a CAPIVIO la plataforma de coinversió",
            home: {
                slogan: "INVERTEIX INTEL·LIGENTMENT. VIU LLIURE.",
                login: "Inicia sessió",
                signup: "Registra't"
            },
            login: "Inicia sessió",
            signup: "Registra't",
            dashboard: "Tauler",
            backToHome: "Torna a l'inici",
            balance: "El teu saldo",
            addMoney: "Afegir diners",
            sendMessage: "Envia un missatge",
            recentMessages: "Missatges recents",
            investNow: "Invertir ara",
            learnMore: "Saber-ne més",
            signInWithGoogle: "Inicia sessió amb Google",
            signInWithMicrosoft: "Inicia sessió amb Microsoft",
            email: "Correu electrònic",
            password: "Contrasenya",
            signIn: "Inicia sessió",
            signOut: "Tanca sessió",
            user: "Usuari",
            none: "Cap",
            emailNotVerified: "Correu electrònic no verificat",
            emailVerified: "Correu electrònic verificat",
            firstNameRequired: "Nom (obligatori)",
            lastName1Required: "Primer cognom (obligatori)",
            lastName2Optional: "Segon cognom (opcional)",
            confirmPassword: "Confirma la contrasenya",
            confirmPasswordRequired: "Es requereix confirmar la contrasenya",
            passwordsDoNotMatch: "Les contrasenyes no coincideixen",
            creatingAccount: "Creant compte...",
            googleSignInError: "Error iniciant sessió amb Google",
            microsoftSignInError: "Error iniciant sessió amb Microsoft",
            googleSignUpError: "Error iniciant sessió amb Google",
            microsoftSignUpError: "Error iniciant sessió amb Microsoft",
            alreadyHaveAccount: "Ja tens un compte?",
            signupError: "Error iniciant sessió",
            loginError: "Error iniciant sessió",
            resetPassword: "Restableix la contrasenya",
            sending: "Enviant...",
            rememberPassword: "Recordes la contrasenya?",
            invalidEmail: "Correu electrònic invàlid",
            emailRequired: "Es requereix correu electrònic",
            passwordRequired: "Es requereix contrasenya",
            passwordMinLength: "La contrasenya ha de tenir almenys 6 caràcters",
            addMessage: "Afegir missatge",
            fetchMessages: "Recuperar missatges",
            storage: "Almacenament",
            uploadFile: "Pujar fitxer",
            viewUploadedFile: "Veure fitxer pujat",
            cloudFunction: "Funció en la núvol",
            callHelloWorld: "Trucar helloWorld Function",
            result: "Resultat",
            platformName: "CAPIVIO",
            welcomeDashboard: "Benvingut al seu tauler",
            dashboardDescription: "Administreu les vostres inversions i seguiu la vostra cartera aquí.",
            enterValidAmount: "Si us plau, introdueixi una quantitat vàlida.",
            balanceUpdated: "Saldo actualitzat!",
            balanceUpdateError: "Error actualitzant saldo.",
            msgStatus: "Estat del missatge",
            unknownUser: "Usuari desconegut",
            decryptionFailed: "[Desencriptació fallida]",
            decryptionError: "[Error de desencriptació]",
            viewCollections: "Veure coleccions de Firestore",
            promoteUserToAdmin: "Promoure usuari a administrador",
            userNotFound: "Usuari no trobat.",
            userPromoted: "Usuari promogut a administrador!",
            promoteError: "Error:",
            investmentOverview: "Resum d'inversió",
            noInvestmentHistory: "Encara no hi ha històric d'inversió.",
            on: "en",
            recentActivity: "Activitat recent",
            noRecentActivity: "No hi ha activitat recent.",
            availableOpportunities: "Oportunitats d'inversió disponibles",
            loadingOpportunities: "Carregant oportunitats...",
            min: "min",
            return: "tornar",
            months: "hilabete",
            totalAmount: "Quantitat total",
            noOpportunities: "No hi ha oportunitats d'inversió disponibles en aquest moment.",
            fetchCollectionsError: "Error recuperant col·leccions:",
            firestoreCollections: "Col·leccions de Firestore",
            loading: "Carregant...",
            noDocumentsFound: "No s'han trobat documents.",
            signingIn: "Iniciant sessió...",
            signUpWithGoogle: "Registrar-se amb Google",
            signUpWithMicrosoft: "Registrar-se amb Microsoft",
            userEmail: "Correu electrònic de l'usuari",
            promote: "Promoure",
            initializeSampleData: "Inicialitzar dades d'exemple",
            firebaseDemoPage: "Pàgina de demostració de Firebase",
            signInEmailPassword: "Accedi con email e password",
            resetPasswordError: "Errore ao redefinir a senha.",
            checkEmailForReset: "Comprova el teu correu per instruccions de restabliment.",
            agents: {
                manageButton: "Gestió d'Agents (Captadors)",
                avgScore: "Puntuació mitjana",
                name: "Nom",
                feedbackCount: "Nombre de valoracions",
                backToAdmin: "Tornar al panell d'administració",
                title: "Gestió d'Agents (Captadors)",
                listTitle: "Llistat d'Agents",
                noAgents: "No hi ha agents per mostrar.",
                type: "Tipus",
                user: "Usuari",
                active: "Actiu",
                achievements: "Logros",
                select: "Seleccionar",
                yes: "Sí",
                no: "No",
                view: "Veure",
                exportCSV: "Exportar Ranking CSV",
                exportPDF: "Exportar PDF",
                createTestAgents: "Crear Agents de Prova",
                creating: "Creant...",
                viewDetails: "Veure detalls de l'agent i el seu rendiment",
                editAgent: "Editar información del agente",
                blockAgent: "Bloquejar o desactivar agent",
                rankingTitle: "Classificació d'Agents",
                detailTitle: "Detall de l'Agent",
                tier: "Nivell",
                associatedOpportunities: "Oportunitats associées",
                operations: "Operacions",
                opportunity: "Oportunitat",
                amount: "Import",
                date: "Data",
                status: "Estat",
                score: "Puntuació",
                feedback: "Comentari",
                fullProfile: "Perfil complet de l'agent",
                recentNotifications: "Notificacions recents",
                close: "Tancar",
                opportunities: "Oportunitats",
                commissions: "Comissions",
                actions: "Accions",
                all: "Totes",
            },
            admin: {
                goToAdminPanel: "Panel d'administració",
                title: "Títol",
                agent: "Agente",
                amount: "Monto",
                date: "Data",
                actions: "Accions",
                viewAgent: "Veure Agent",
                approve: "Aprobar",
                reject: "Rechazar",
                agentDetails: "Detalls de l'Agent",
                close: "Tancar",
                rejectOpportunity: "Rechazar Oportunitat",
                rejectReason: "Motiu del rebuig",
                cancel: "Cancelar",
                opportunityApproved: "Oportunitat aprovada.",
                errorApproving: "Error al aprovar l'oportunitat.",
                opportunityRejected: "Oportunidad rebutjada.",
                errorRejecting: "Error al rebutjar l'oportunitat.",
                noPendingOpportunities: "No hi ha oportunitats pendents.",
            },
            header: { dashboard: "Tauler", logout: "Tancar sessió" },
            menu: {
                dashboard: "Tauler",
                opportunities: "Oportunitat",
                investments: "Inversions",
                portfolio: "Portafolio",
                kyc: "Verificació KYC",
                financialVerification: "Verificación Financiera",
                offboarding: "Desboarding",
                adminPanel: "Panel d'administració",
                kycManagement: "Gestió KYC",
                offboardingManagement: "Gestión Desboarding",
                agentes: "Agentes",
                collections: "Colecciones",
                logout: "Tancar sessió",
                main: "Principal",
                tools: "Herramientas",
                admin: "Administrador",
                preferences: "Preferencias",
                messages: "Mensajes",
            },
            profile: {
                title: "My Profile",
                identity: "Identity & Account",
                investmentProfile: "Investment Profile",
                compliance: "Araudi Betetze eta Segurtasuna",
                preferences: "Preferences",
                name: "Name",
                email: "Email",
                phone: "Phone",
                kycStatus: "KYC Status",
                kycButton: "Submit/Update KYC",
                role: "Role",
                createdAt: "Account Created At",
                lastLogin: "Last Login",
                notAvailable: "Not available",
                portfolioValue: "Portfolio Value",
                numInvestments: "Number of Investments",
                riskLevel: "Preferred Risk Level",
                lastInvestment: "Last Investment Date",
                topOpportunities: "Top 3 Invested Opportunities",
                downloadData: "Download My Data (GDPR)",
                loginHistory: "Login History",
                language: "Language Preference",
                darkMode: "Dark Mode",
                notifications: "Notification Preferences",
                emailAlerts: "Email alerts (opportunity updates)",
                investmentUpdates: "Investment status updates",
                monthlySummary: "Monthly portfolio summary",
                consent: "Consent for Communications",
                consentSaved: "Consent updated successfully!",
                consentError: "Failed to update consent.",
                opportunityName: "Opportunity Name",
                opportunityCode: "Opportunity Code",
                investedAmount: "Invested Amount",
                expectedReturn: "Expected Return (%)",
                estimatedReturn: "Estimated Return",
                exportFileName: "nire_aukera",
            },
            opportunity: {
                title: "Title",
                description: "Description",
                propertyType: "Property Type",
                location: "Location",
                totalBudget: "Total Budget (€)",
                expectedReturn: "Expected Return (%)",
                executionTime: "Execution Time (months)",
                minimumInvestment: "Minimum Investment (€)",
                projectImages: "Project Images",
                uploadImages: "Upload Images",
                legalDocumentation: "Legal Documentation",
                uploadDocuments: "Upload Documents",
                minCharacters: "minimum characters",
                minBudget: "Minimum €100,000",
                returnRange: "Between 5% and 50%",
                executionRange: "Between 6 and 120 months",
                submittedForApproval: "Opportunity submitted for approval",
                creationError: "Error creating opportunity",
                editProject: "Edit Project",
                createNewProject: "Create New Project",
                createProject: "Create Project",
            },
            common: {
                cancel: "Cancel",
                back: "Back",
                next: "Next",
                processing: "Processing...",
                update: "Update",
            },
        },
    },
    fr: {
        translation: {
            welcome: "Bienvenue sur CAPIVIO la plateforme de co-investissement",
            home: {
                slogan: "INVESTISSEZ MALIN. VIVEZ LIBRE.",
                login: "Connexion",
                signup: "S'inscrire"
            },
            login: "Connexion",
            signup: "S'inscrire",
            dashboard: "Tableau de bord",
            backToHome: "Retour à l'accueil",
            balance: "Votre solde",
            addMoney: "Ajouter de l'argent",
            sendMessage: "Envoyer un message",
            recentMessages: "Messages récents",
            investNow: "Investir maintenant",
            learnMore: "En savoir plus",
            signInWithGoogle: "Se connecter avec Google",
            signInWithMicrosoft: "Se connecter avec Microsoft",
            email: "Email",
            password: "Mot de passe",
            signIn: "Se connecter",
            signOut: "Se déconnecter",
            user: "Utilisateur",
            none: "Aucun",
            emailNotVerified: "Email non vérifié",
            emailVerified: "Email vérifié",
            firstNameRequired: "Prénom (requis)",
            lastName1Required: "Nom (requis)",
            lastName2Optional: "Nom (optionnel)",
            confirmPassword: "Confirmer le mot de passe",
            confirmPasswordRequired: "Le mot de passe doit être confirmé",
            passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
            creatingAccount: "Création de compte...",
            googleSignInError: "Erreur de connexion avec Google",
            microsoftSignInError: "Erreur de connexion avec Microsoft",
            googleSignUpError: "Erreur de connexion avec Google",
            microsoftSignUpError: "Erreur de connexion avec Microsoft",
            alreadyHaveAccount: "Vous avez déjà un compte ?",
            signupError: "Erreur d'inscription",
            loginError: "Erreur de connexion",
            resetPassword: "Réinitialiser le mot de passe",
            sending: "Envoi...",
            rememberPassword: "Souvenez-vous de votre mot de passe ?",
            invalidEmail: "Email invalide",
            emailRequired: "Email requis",
            passwordRequired: "Mot de passe requis",
            passwordMinLength: "Le mot de passe doit comporter au moins 6 chiffres",
            addMessage: "Ajouter un message",
            fetchMessages: "Récupérer les messages",
            storage: "Stockage",
            uploadFile: "Télécharger un fichier",
            viewUploadedFile: "Voir le fichier téléchargé",
            cloudFunction: "Fonction cloud",
            callHelloWorld: "Appeler la fonction helloWorld",
            result: "Résultat",
            platformName: "CAPIVIO",
            welcomeDashboard: "Bienvenue sur votre tableau de bord",
            dashboardDescription: "Gérez vos investissements et suivez votre portefeuille ici.",
            enterValidAmount: "Veuillez entrer une quantité valide.",
            balanceUpdated: "Solde mis à jour !",
            balanceUpdateError: "Erreur de mise à jour du solde.",
            msgStatus: "État du message",
            unknownUser: "Utilisateur inconnu",
            decryptionFailed: "[Déchiffrement échoué]",
            decryptionError: "[Erreur de déchiffrement]",
            viewCollections: "Voir les collections Firestore",
            promoteUserToAdmin: "Promouvoir l'utilisateur en administrateur",
            userNotFound: "Utilisateur non trouvé.",
            userPromoted: "Utilisateur promu en administrateur !",
            promoteError: "Erreur:",
            investmentOverview: "Aperçu de l'investissement",
            noInvestmentHistory: "Pas d'historique d'investissement.",
            on: "sur",
            recentActivity: "Activité récente",
            noRecentActivity: "Pas d'activité récente.",
            availableOpportunities: "Oportunités d'investissement disponibles",
            loadingOpportunities: "Chargement des opportunités...",
            min: "min",
            return: "retour",
            months: "mois",
            totalAmount: "Montant total",
            noOpportunities: "Pas d'opportunités d'investissement disponibles en ce moment.",
            fetchCollectionsError: "Erreur de récupération des collections:",
            firestoreCollections: "Collections Firestore",
            loading: "Chargement...",
            noDocumentsFound: "Aucun document trouvé.",
            signingIn: "Connexion...",
            signUpWithGoogle: "S'inscrire avec Google",
            signUpWithMicrosoft: "S'inscrire avec Microsoft",
            userEmail: "Email de l'utilisateur",
            promote: "Promouvoir",
            initializeSampleData: "Initialiser les données d'échantillon",
            firebaseDemoPage: "Pagina demo Firebase",
            signInEmailPassword: "Accedi con email e password",
            resetPasswordError: "Errore nel reimpostare la password.",
            checkEmailForReset: "Egiaztatu zure emaila berrezartzeko argibideak.",
            agents: {
                manageButton: "Gestion des Agents (Capteurs)",
                avgScore: "Score moyen",
                name: "Nom",
                feedbackCount: "Nombre d'avis",
                backToAdmin: "Retour au panneau d'administration",
                title: "Gestion des Agents (Capteurs)",
                listTitle: "Liste des Agents",
                noAgents: "Aucun agent à afficher.",
                type: "Type",
                user: "Utilisateur",
                active: "Actif",
                achievements: "Réalisations",
                select: "Sélectionner",
                yes: "Oui",
                no: "Non",
                view: "Vedi",
                exportCSV: "Exporter le classement des agents CSV",
                exportPDF: "Exportar PDF",
                createTestAgents: "Créer des Agents de Test",
                creating: "Création...",
                viewDetails: "Voir les détails de l'agent et son rendement",
                editAgent: "Modifier les informations de l'agent",
                blockAgent: "Bloquer ou désactiver l'agent",
                rankingTitle: "Classement des Agents",
                detailTitle: "Détail de l'Agent",
                tier: "Niveau",
                associatedOpportunities: "Oportunidades associées",
                operations: "Opérations",
                opportunity: "Oportunidad",
                amount: "Montant",
                date: "Date",
                status: "Statut",
                score: "Puntuation",
                feedback: "Commentaire",
                fullProfile: "Profil complet de l'agent",
                recentNotifications: "Notifications récentes",
                close: "Fermer",
                opportunities: "Opportunidades",
                commissions: "Comissions",
                actions: "Ações",
                all: "Toutes",
            },
            admin: {
                goToAdminPanel: "Panneau d'administration",
                title: "Titre",
                agent: "Agente",
                amount: "Montant",
                date: "Date",
                actions: "Actions",
                viewAgent: "Vedi Agente",
                approve: "Approuver",
                reject: "Rifiuter",
                agentDetails: "Détails de l'Agente",
                close: "Fermer",
                rejectOpportunity: "Rifiuter Oportunité",
                rejectReason: "Motif du refus",
                cancel: "Annuler",
                opportunityApproved: "Oportunidad aprobada.",
                errorApproving: "Erreur d'approbation de l'opportunité.",
                opportunityRejected: "Oportunidad réfusée.",
                errorRejecting: "Erreur de refus de l'opportunité.",
                noPendingOpportunities: "Aucune opportunité en attente.",
            },
            header: { dashboard: "Tableau de bord", logout: "Déconnexion" },
            menu: {
                dashboard: "Tableau de bord",
                opportunities: "Oportunités",
                investments: "Investimenti",
                portfolio: "Portafoglio",
                kyc: "Vérification KYC",
                financialVerification: "Vérification financière",
                offboarding: "Déboarding",
                adminPanel: "Panneau d'administration",
                kycManagement: "Gestion KYC",
                offboardingManagement: "Gestion Déboarding",
                agentes: "Agentes",
                collections: "Collections",
                logout: "Se déconnecter",
                main: "Principal",
                tools: "Outils",
                admin: "Administrateur",
                preferences: "Préférences",
                messages: "Mensages",
            },
            profile: {
                title: "My Profile",
                identity: "Identity & Account",
                investmentProfile: "Investment Profile",
                compliance: "Compliance & Security",
                preferences: "Preferences",
                name: "Name",
                email: "Email",
                phone: "Phone",
                kycStatus: "KYC Status",
                kycButton: "Submit/Update KYC",
                role: "Role",
                createdAt: "Account Created At",
                lastLogin: "Last Login",
                notAvailable: "Not available",
                portfolioValue: "Portfolio Value",
                numInvestments: "Number of Investments",
                riskLevel: "Preferred Risk Level",
                lastInvestment: "Last Investment Date",
                topOpportunities: "Top 3 Invested Opportunities",
                downloadData: "Download My Data (GDPR)",
                loginHistory: "Login History",
                language: "Language Preference",
                darkMode: "Dark Mode",
                notifications: "Notification Preferences",
                emailAlerts: "Email alerts (opportunity updates)",
                investmentUpdates: "Investment status updates",
                monthlySummary: "Monthly portfolio summary",
                consent: "Consent for Communications",
                consentSaved: "Consent updated successfully!",
                consentError: "Failed to update consent.",
                opportunityName: "Opportunity Name",
                opportunityCode: "Opportunity Code",
                investedAmount: "Invested Amount",
                expectedReturn: "Expected Return (%)",
                estimatedReturn: "Estimated Return",
                exportFileName: "my_opportunities",
            },
            opportunity: {
                title: "Title",
                description: "Description",
                propertyType: "Property Type",
                location: "Location",
                totalBudget: "Total Budget (€)",
                expectedReturn: "Expected Return (%)",
                executionTime: "Execution Time (months)",
                minimumInvestment: "Minimum Investment (€)",
                projectImages: "Project Images",
                uploadImages: "Upload Images",
                legalDocumentation: "Legal Documentation",
                uploadDocuments: "Upload Documents",
                minCharacters: "minimum characters",
                minBudget: "Minimum €100,000",
                returnRange: "Between 5% and 50%",
                executionRange: "Between 6 and 120 months",
                submittedForApproval: "Opportunity submitted for approval",
                creationError: "Error creating opportunity",
                editProject: "Edit Project",
                createNewProject: "Create New Project",
                createProject: "Create Project",
            },
            common: {
                cancel: "Cancel",
                back: "Back",
                next: "Next",
                processing: "Processing...",
                update: "Update",
            },
        },
    },
    eu: {
        translation: {
            welcome: "Ongi etorri CAPIVIO inbertsio-plataformara",
            home: {
                slogan: "INBERTITU ADIMENEZ. BIZI ASKE.",
                login: "Hasi saioa",
                signup: "Erregistratu"
            },
            login: "Hasi saioa",
            signup: "Erregistratu",
            dashboard: "Arbela",
            backToHome: "Hasierara itzuli",
            balance: "Zure saldoa",
            addMoney: "Dirua sartu",
            sendMessage: "Mezua bidali",
            recentMessages: "Azken mezuak",
            investNow: "Inbertitu orain",
            learnMore: "Gehiago jakin",
            signInWithGoogle: "Hasi saioa Google-rekin",
            signInWithMicrosoft: "Hasi saioa Microsoft-ekin",
            email: "Posta elektronikoa",
            password: "Pasahitza",
            signIn: "Hasi saioa",
            signOut: "Saioa itxi",
            user: "Erabiltzailea",
            none: "Bat ere ez",
            emailNotVerified: "Posta elektronikoa egiaztatu gabe",
            emailVerified: "Posta elektronikoa egiaztatuta",
            firstNameRequired: "Izena (beharrezkoa)",
            lastName1Required: "Lehen abizena (beharrezkoa)",
            lastName2Optional: "Bigarren abizena (aukerakoa)",
            confirmPassword: "Berretsi pasahitza",
            confirmPasswordRequired: "Pasahitza berrestea beharrezkoa da",
            passwordsDoNotMatch: "Pasahitzak ez datoz bat",
            creatingAccount: "Kontua sortzen...",
            googleSignInError: "Errorea Google-rekin saioa hastean",
            microsoftSignInError: "Errorea Microsoft-ekin saioa hastean",
            googleSignUpError: "Errorea Google-rekin erregistratzean",
            microsoftSignUpError: "Errorea Microsoft-ekin erregistratzean",
            alreadyHaveAccount: "Baduzu kontu bat?",
            signupError: "Errorea erregistratzean",
            loginError: "Errorea saioa hastean",
            resetPassword: "Pasahitza berrezarri",
            sending: "Bidalten...",
            rememberPassword: "Pasahitza gogoratzen duzu?",
            invalidEmail: "Posta elektroniko baliogabea",
            emailRequired: "Posta elektronikoa beharrezkoa da",
            passwordRequired: "Pasahitza beharrezkoa da",
            passwordMinLength: "Pasahitzak gutxienez 6 karaktere izan behar ditu",
            addMessage: "Mezua gehitu",
            fetchMessages: "Mezuak eskuratu",
            storage: "Biltegiratzea",
            uploadFile: "Fitxategia igo",
            viewUploadedFile: "Igotako fitxategia ikusi",
            cloudFunction: "Hodeiko funtzioa",
            callHelloWorld: "Deitu helloWorld funtzioari",
            result: "Emaitza",
            platformName: "CAPIVIO",
            welcomeDashboard: "Ongi etorri zure panelera",
            dashboardDescription: "Kudeatu zure inbertsioak eta jarraitu zure zorroa hemen.",
            enterValidAmount: "Sartu baliozko zenbateko bat, mesedez.",
            balanceUpdated: "Saldoa eguneratuta!",
            balanceUpdateError: "Errorea saldoa eguneratzean.",
            msgStatus: "Mezuaren egoera",
            unknownUser: "Erabiltzaile ezezaguna",
            decryptionFailed: "[Deszifratzeak huts egin du]",
            decryptionError: "[Deszifratze errorea]",
            viewCollections: "Ikusi Firestore bildumak",
            promoteUserToAdmin: "Erabiltzailea administratzaile bihurtu",
            userNotFound: "Erabiltzailea ez da aurkitu.",
            userPromoted: "Erabiltzailea administratzaile bihurtu da!",
            promoteError: "Errorea:",
            investmentOverview: "Inbertsioen laburpena",
            noInvestmentHistory: "Oraindik ez dago inbertsio historiarik.",
            on: "data:",
            recentActivity: "Azken jarduera",
            noRecentActivity: "Ez dago azken jarduerarik.",
            availableOpportunities: "Inbertsio aukera eskuragarriak",
            loadingOpportunities: "Aukerak kargatzen...",
            min: "min",
            return: "itzulera",
            months: "hilabete",
            totalAmount: "Zenbateko osoa",
            noOpportunities: "Ez dago inbertsio aukerarik une honetan.",
            fetchCollectionsError: "Errorea bildumak eskuratzean:",
            firestoreCollections: "Firestore bildumak",
            loading: "Kargatzen...",
            noDocumentsFound: "Ez da dokumenturik aurkitu.",
            signingIn: "Saioa hasten...",
            signUpWithGoogle: "Erregistratu Google-rekin",
            signUpWithMicrosoft: "Erregistratu Microsoft-ekin",
            userEmail: "Erabiltzailearen posta elektronikoa",
            promote: "Sustatu",
            initializeSampleData: "Hasi lagin-datuekin",
            firebaseDemoPage: "Firebase demo orria",
            signInEmailPassword: "Accedi con email e password",
            resetPasswordError: "Errorea pasahitza berrezartzean.",
            checkEmailForReset: "Egiaztatu zure emaila berrezartzeko argibideak.",
            agents: {
                manageButton: "Agentearen kudeaketa (Captadores)",
                avgScore: "Batez besteko puntuazioa",
                name: "Izena",
                feedbackCount: "Iritzi kopurua",
                backToAdmin: "Itzuli administrazio panelera",
                title: "Agentearen kudeaketa (Captadores)",
                listTitle: "Agentearen zerrenda",
                noAgents: "Ez dago agenterik erakusteko.",
                type: "Mota",
                user: "Erabiltzailea",
                active: "Aktibo",
                achievements: "Logros",
                select: "Hautatu",
                yes: "Bai",
                no: "Ez",
                view: "Ikusi",
                exportCSV: "Agentearen sailkapena esportatu (CSV)",
                exportPDF: "Esportar PDF",
                createTestAgents: "Crear Agents de Prova",
                creating: "Creando...",
                viewDetails: "Ver detalles del agente y su rendimiento",
                editAgent: "Editar informações do agente",
                blockAgent: "Bloquejar o desactivar agent",
                rankingTitle: "Classificação de Agentes",
                detailTitle: "Detalhe do Agente",
                tier: "Nivel",
                associatedOpportunities: "Oportunidades associées",
                operations: "Operacions",
                opportunity: "Oportunidad",
                amount: "Montant",
                date: "Data",
                status: "Statut",
                score: "Puntuazioa",
                feedback: "Comentário",
                fullProfile: "Perfil complet de l'agent",
                recentNotifications: "Notificações recentes",
                close: "Tancar",
                opportunities: "Oportunidades",
                commissions: "Comissions",
                actions: "Ações",
                all: "Todas",
            },
            admin: {
                goToAdminPanel: "Administrazio panela",
                title: "Título",
                agent: "Agente",
                amount: "Monto",
                date: "Fecha",
                actions: "Acciones",
                viewAgent: "Ver Agente",
                approve: "Aprobar",
                reject: "Rechazar",
                agentDetails: "Detalles del Agente",
                close: "Cerrar",
                rejectOpportunity: "Rechazar Oportunidad",
                rejectReason: "Motivo del rechazo",
                cancel: "Cancelar",
                opportunityApproved: "Oportunidad aprobada.",
                errorApproving: "Error al aprobar la oportunidad.",
                opportunityRejected: "Oportunidad rechazada.",
                errorRejecting: "Error al rechazar la oportunidad.",
                noPendingOpportunities: "No hay oportunidades pendientes.",
            },
            header: { dashboard: "Arbela", logout: "Saioa itxi" },
            menu: {
                dashboard: "Arbela",
                opportunities: "Oportunitat",
                investments: "Inversions",
                portfolio: "Portafolio",
                kyc: "Verificació KYC",
                financialVerification: "Verificación Financiera",
                offboarding: "Desboarding",
                adminPanel: "Panel d'administració",
                kycManagement: "Gestió KYC",
                offboardingManagement: "Gestión Desboarding",
                agentes: "Agentes",
                collections: "Coleccions",
                logout: "Tancar sessió",
                main: "Principal",
                tools: "Herramientas",
                admin: "Administrador",
                preferences: "Preferencias",
                messages: "Mensajes",
            },
            profile: {
                title: "My Profile",
                identity: "Identity & Account",
                investmentProfile: "Investment Profile",
                compliance: "Araudi Betetze eta Segurtasuna",
                preferences: "Preferences",
                name: "Name",
                email: "Email",
                phone: "Phone",
                kycStatus: "KYC Status",
                kycButton: "Submit/Update KYC",
                role: "Role",
                createdAt: "Account Created At",
                lastLogin: "Last Login",
                notAvailable: "Not available",
                portfolioValue: "Portfolio Value",
                numInvestments: "Number of Investments",
                riskLevel: "Preferred Risk Level",
                lastInvestment: "Last Investment Date",
                topOpportunities: "Top 3 Invested Opportunities",
                downloadData: "Download My Data (GDPR)",
                loginHistory: "Login History",
                language: "Language Preference",
                darkMode: "Dark Mode",
                notifications: "Notification Preferences",
                emailAlerts: "Email alerts (opportunity updates)",
                investmentUpdates: "Investment status updates",
                monthlySummary: "Monthly portfolio summary",
                consent: "Consent for Communications",
                consentSaved: "Consent updated successfully!",
                consentError: "Failed to update consent.",
                opportunityName: "Opportunity Name",
                opportunityCode: "Opportunity Code",
                investedAmount: "Invested Amount",
                expectedReturn: "Expected Return (%)",
                estimatedReturn: "Estimated Return",
                exportFileName: "nire_aukera",
            },
            opportunity: {
                title: "Title",
                description: "Description",
                propertyType: "Property Type",
                location: "Location",
                totalBudget: "Total Budget (€)",
                expectedReturn: "Expected Return (%)",
                executionTime: "Execution Time (months)",
                minimumInvestment: "Minimum Investment (€)",
                projectImages: "Project Images",
                uploadImages: "Upload Images",
                legalDocumentation: "Legal Documentation",
                uploadDocuments: "Upload Documents",
                minCharacters: "minimum characters",
                minBudget: "Minimum €100,000",
                returnRange: "Between 5% and 50%",
                executionRange: "Between 6 and 120 months",
                submittedForApproval: "Opportunity submitted for approval",
                creationError: "Error creating opportunity",
                editProject: "Edit Project",
                createNewProject: "Create New Project",
                createProject: "Create Project",
            },
            common: {
                cancel: "Cancel",
                back: "Back",
                next: "Next",
                processing: "Processing...",
                update: "Update",
            },
        },
    },
    pt: {
        translation: {
            welcome: "Bem-vindo ao CAPIVIO, a plataforma de co-investimento",
            home: {
                slogan: "INVISTA COM INTELIGÊNCIA. VIVA LIVRE.",
                login: "Entrar",
                signup: "Cadastrar-se"
            },
            login: "Entrar",
            signup: "Registrar-se",
            dashboard: "Painel",
            backToHome: "Voltar para o início",
            balance: "Seu saldo",
            addMoney: "Adicionar dinheiro",
            sendMessage: "Enviar uma mensagem",
            recentMessages: "Mensagens recentes",
            investNow: "Investir agora",
            learnMore: "Saiba mais",
            signInWithGoogle: "Entrar com Google",
            signInWithMicrosoft: "Entrar com Microsoft",
            email: "Email",
            password: "Senha",
            signIn: "Entrar",
            signOut: "Sair",
            user: "Usuário",
            none: "Nenhum",
            emailNotVerified: "Email não verificado",
            emailVerified: "Email verificado",
            firstNameRequired: "Primeiro nome (obrigatório)",
            lastName1Required: "Sobrenome 1 (obrigatório)",
            lastName2Optional: "Sobrenome 2 (opcional)",
            confirmPassword: "Confirmar senha",
            confirmPasswordRequired: "Senha de confirmação é obrigatória",
            passwordsDoNotMatch: "Senhas não correspondem",
            creatingAccount: "Criando conta...",
            googleSignInError: "Erro ao entrar com Google",
            microsoftSignInError: "Erro ao entrar com Microsoft",
            googleSignUpError: "Erro ao se registrar com Google",
            microsoftSignUpError: "Erro ao se registrar com Microsoft",
            alreadyHaveAccount: "Já tem uma conta?",
            signupError: "Erro ao se registrar",
            loginError: "Erro ao entrar",
            resetPassword: "Redefinir senha",
            sending: "Enviando...",
            rememberPassword: "Lembra da sua senha?",
            invalidEmail: "Email inválido",
            emailRequired: "Email é obrigatório",
            passwordRequired: "Senha é obrigatória",
            passwordMinLength: "Senha deve ter pelo menos 6 dígitos",
            addMessage: "Adicionar mensagem",
            fetchMessages: "Recuperar mensagens",
            storage: "Armazenamento",
            uploadFile: "Enviar arquivo",
            viewUploadedFile: "Ver arquivo enviado",
            cloudFunction: "Função em nuvem",
            callHelloWorld: "Chamar função helloWorld",
            result: "Resultado",
            platformName: "CAPIVIO",
            welcomeDashboard: "Bem-vindo ao seu painel",
            dashboardDescription: "Gerencie suas investimentos e acompanhe seu portfólio aqui.",
            enterValidAmount: "Por favor, insira uma quantidade válida.",
            balanceUpdated: "Saldo atualizado!",
            balanceUpdateError: "Erro ao atualizar saldo.",
            msgStatus: "Status da mensagem",
            unknownUser: "Usuário desconhecido",
            decryptionFailed: "[Desencriptação falhou]",
            decryptionError: "[Erro de desencriptação]",
            viewCollections: "Ver coleções Firestore",
            promoteUserToAdmin: "Promover usuário para administrador",
            userNotFound: "Usuário não encontrado.",
            userPromoted: "Usuário promovido para administrador!",
            promoteError: "Erro:",
            investmentOverview: "Visão geral da investimento",
            noInvestmentHistory: "Ainda não há histórico de investimento.",
            on: "em",
            recentActivity: "Atividade recente",
            noRecentActivity: "Não há atividade recente.",
            availableOpportunities: "Oportunidades de investimento disponíveis",
            loadingOpportunities: "Carregando oportunidades...",
            min: "min",
            return: "retornar",
            months: "meses",
            totalAmount: "Quantidade total",
            noOpportunities: "Não há oportunidades de investimento disponíveis no momento.",
            fetchCollectionsError: "Erro ao recuperar coleções:",
            firestoreCollections: "Coleções Firestore",
            loading: "Carregando...",
            noDocumentsFound: "Nenhum documento encontrado.",
            signingIn: "Entrando...",
            signUpWithGoogle: "Registrar com Google",
            signUpWithMicrosoft: "Registrar com Microsoft",
            userEmail: "Email do usuário",
            promote: "Promover",
            initializeSampleData: "Inicializar dados de exemplo",
            firebaseDemoPage: "Página de demonstração do Firebase",
            signInEmailPassword: "Accedi con email e password",
            resetPasswordError: "Erro ao redefinir a senha.",
            checkEmailForReset: "Verifique seu email para instruções de redefinição.",
            agents: {
                manageButton: "Gestão de Agentes (Captadores)",
                avgScore: "Pontuação média",
                name: "Nome",
                feedbackCount: "Quantidade de avaliações",
                backToAdmin: "Voltar ao painel de administração",
                title: "Gestão de Agentes (Captadores)",
                listTitle: "Lista de Agentes",
                noAgents: "Nenhum agente para exibir.",
                type: "Tipo",
                user: "Usuário",
                active: "Ativo",
                achievements: "Conquistas",
                select: "Selecionar",
                yes: "Sim",
                no: "Não",
                view: "Ver",
                exportCSV: "Exportar classificação de agentes CSV",
                exportPDF: "Exportar PDF",
                createTestAgents: "Criar Agents de Prova",
                creating: "Criando...",
                viewDetails: "Ver detalhes do agente e seu desempenho",
                editAgent: "Editar informações do agente",
                blockAgent: "Bloquear ou desativar agent",
                rankingTitle: "Classificação de Agentes",
                detailTitle: "Detalhe do Agente",
                tier: "Nível",
                associatedOpportunities: "Oportunidades associadas",
                operations: "Operações",
                opportunity: "Oportunidade",
                amount: "Montant",
                date: "Data",
                status: "Status",
                score: "Pontuação",
                feedback: "Comentário",
                fullProfile: "Perfil completo do agente",
                recentNotifications: "Notificações recentes",
                close: "Fechar",
                opportunities: "Oportunidades",
                commissions: "Comissões",
                actions: "Ações",
                all: "Todas",
            },
            admin: {
                goToAdminPanel: "Painel de Administração",
                title: "Título",
                agent: "Agente",
                amount: "Monto",
                date: "Data",
                actions: "Ações",
                viewAgent: "Ver Agente",
                approve: "Aprobar",
                reject: "Rechazar",
                agentDetails: "Detalhes do Agente",
                close: "Fechar",
                rejectOpportunity: "Rechazar Oportunidade",
                rejectReason: "Motivo do rejeição",
                cancel: "Cancelar",
                opportunityApproved: "Oportunidade aprovada.",
                errorApproving: "Erro ao aprovar a oportunidade.",
                opportunityRejected: "Oportunidade rejeitada.",
                errorRejecting: "Erro ao rejeitar a oportunidade.",
                noPendingOpportunities: "Não há oportunidades pendentes.",
            },
            header: { dashboard: "Painel", logout: "Sair" },
            menu: {
                dashboard: "Painel",
                opportunities: "Oportunitats",
                investments: "Investimentos",
                portfolio: "Portfólio",
                kyc: "Verificação KYC",
                financialVerification: "Verificação Financeira",
                offboarding: "Desboarding",
                adminPanel: "Painel de Administração",
                kycManagement: "Gestão KYC",
                offboardingManagement: "Gestão de Desboarding",
                agentes: "Agentes",
                collections: "Coleções",
                logout: "Sair",
                main: "Principal",
                tools: "Ferramentas",
                admin: "Administrador",
                preferences: "Preferências",
                messages: "Mensagens",
            },
            profile: {
                title: "My Profile",
                identity: "Identity & Account",
                investmentProfile: "Investment Profile",
                compliance: "Araudi Betetze eta Segurtasuna",
                preferences: "Preferences",
                name: "Name",
                email: "Email",
                phone: "Phone",
                kycStatus: "KYC Status",
                kycButton: "Submit/Update KYC",
                role: "Role",
                createdAt: "Account Created At",
                lastLogin: "Last Login",
                notAvailable: "Not available",
                portfolioValue: "Portfolio Value",
                numInvestments: "Number of Investments",
                riskLevel: "Preferred Risk Level",
                lastInvestment: "Last Investment Date",
                topOpportunities: "Top 3 Invested Opportunities",
                downloadData: "Download My Data (GDPR)",
                loginHistory: "Login History",
                language: "Language Preference",
                darkMode: "Dark Mode",
                notifications: "Notification Preferences",
                emailAlerts: "Email alerts (opportunity updates)",
                investmentUpdates: "Investment status updates",
                monthlySummary: "Monthly portfolio summary",
                consent: "Consent for Communications",
                consentSaved: "Consent updated successfully!",
                consentError: "Failed to update consent.",
                opportunityName: "Opportunity Name",
                opportunityCode: "Opportunity Code",
                investedAmount: "Invested Amount",
                expectedReturn: "Expected Return (%)",
                estimatedReturn: "Estimated Return",
                exportFileName: "minhas_oportunidades",
            },
            opportunity: {
                title: "Title",
                description: "Description",
                propertyType: "Property Type",
                location: "Location",
                totalBudget: "Total Budget (€)",
                expectedReturn: "Expected Return (%)",
                executionTime: "Execution Time (months)",
                minimumInvestment: "Minimum Investment (€)",
                projectImages: "Project Images",
                uploadImages: "Upload Images",
                legalDocumentation: "Legal Documentation",
                uploadDocuments: "Upload Documents",
                minCharacters: "minimum characters",
                minBudget: "Minimum €100,000",
                returnRange: "Between 5% and 50%",
                executionRange: "Between 6 and 120 months",
                submittedForApproval: "Opportunity submitted for approval",
                creationError: "Error creating opportunity",
                editProject: "Edit Project",
                createNewProject: "Create New Project",
                createProject: "Create Project",
            },
            common: {
                cancel: "Cancel",
                back: "Back",
                next: "Next",
                processing: "Processing...",
                update: "Update",
            },
        },
    },
    it: {
        translation: {
            welcome: "Benvenuto su CAPIVIO, la piattaforma di co-investimento",
            home: {
                slogan: "INVESTI INTELLIGENTEMENTE. VIVI LIBERO.",
                login: "Accedi",
                signup: "Registrati"
            },
            login: "Accedi",
            signup: "Registrati",
            dashboard: "Cruscotto",
            backToHome: "Torna alla home",
            balance: "Il tuo saldo",
            addMoney: "Aggiungi denaro",
            sendMessage: "Invia un messaggio",
            recentMessages: "Messaggi recenti",
            investNow: "Investi ora",
            learnMore: "Scopri di più",
            signInWithGoogle: "Accedi con Google",
            signInWithMicrosoft: "Accedi con Microsoft",
            email: "Email",
            password: "Password",
            signIn: "Accedi",
            signOut: "Esci",
            user: "Utente",
            none: "Nessuno",
            emailNotVerified: "Email non verificata",
            emailVerified: "Email verificato",
            firstNameRequired: "Nome (obbligatorio)",
            lastName1Required: "Cognome 1 (obbligatorio)",
            lastName2Optional: "Cognome 2 (opzionale)",
            confirmPassword: "Conferma password",
            confirmPasswordRequired: "La password di conferma è obbligatoria",
            passwordsDoNotMatch: "Le password non corrispondono",
            creatingAccount: "Creazione di account...",
            googleSignInError: "Errore di accesso con Google",
            microsoftSignInError: "Errore di accesso con Microsoft",
            googleSignUpError: "Errore di accesso con Google",
            microsoftSignUpError: "Errore di accesso con Microsoft",
            alreadyHaveAccount: "Hai già un account?",
            signupError: "Errore di accesso",
            loginError: "Errore di accesso",
            resetPassword: "Reimposta password",
            sending: "Invio...",
            rememberPassword: "Ti ricordi la password?",
            invalidEmail: "Email non valida",
            emailRequired: "Email obbligatoria",
            passwordRequired: "Password obbligatoria",
            passwordMinLength: "La password deve essere lunga almeno 6 cifre",
            addMessage: "Aggiungi messaggio",
            fetchMessages: "Recupera messaggi",
            storage: "Archiviazione",
            uploadFile: "Carica file",
            viewUploadedFile: "Visualizza file caricato",
            cloudFunction: "Funzione cloud",
            callHelloWorld: "Chiama funzione helloWorld",
            result: "Risultato",
            platformName: "CAPIVIO",
            welcomeDashboard: "Benvenuto nel tuo cruscotto",
            dashboardDescription: "Gestisci i tuoi investimenti e traccia il tuo portafoglio qui.",
            enterValidAmount: "Per favore inserisci una quantità valida.",
            balanceUpdated: "Saldo aggiornato!",
            balanceUpdateError: "Errore di aggiornamento saldo.",
            msgStatus: "Stato del messaggio",
            unknownUser: "Utente sconosciuto",
            decryptionFailed: "[Decriptazione fallita]",
            decryptionError: "[Errore di decriptazione]",
            viewCollections: "Visualizza collezioni Firestore",
            promoteUserToAdmin: "Promuovi utente a amministratore",
            userNotFound: "Utente non trovato.",
            userPromoted: "Utente promosso a amministratore!",
            promoteError: "Errore:",
            investmentOverview: "Panoramica dell'investimento",
            noInvestmentHistory: "Non c'è ancora storia dell'investimento.",
            on: "su",
            recentActivity: "Attività recente",
            noRecentActivity: "Non c'è attività recente.",
            availableOpportunities: "Opportunità di investimento disponibili",
            loadingOpportunities: "Caricamento opportunità...",
            min: "min",
            return: "ritorno",
            months: "mesi",
            totalAmount: "Quantità totale",
            noOpportunities: "Non ci sono opportunità di investimento disponibili in questo momento.",
            fetchCollectionsError: "Errore di recupero collezioni:",
            firestoreCollections: "Collezioni Firestore",
            loading: "Caricamento...",
            noDocumentsFound: "Nessun documento trovato.",
            signingIn: "Accesso...",
            signUpWithGoogle: "Registrati con Google",
            signUpWithMicrosoft: "Registrati con Microsoft",
            userEmail: "Email utente",
            promote: "Promuovi",
            initializeSampleData: "Inizializza dati di esempio",
            firebaseDemoPage: "Pagina demo Firebase",
            signInEmailPassword: "Accedi con email e password",
            resetPasswordError: "Errore nel reimpostare la password.",
            checkEmailForReset: "Controlla la tua email per le istruzioni di redefinição.",
            agents: {
                manageButton: "Gestione Agenti (Captatori)",
                avgScore: "Punteggio medio",
                name: "Nome",
                feedbackCount: "Numero di feedback",
                backToAdmin: "Tornar al pannello di amministrazione",
                title: "Gestione Agenti (Captatori)",
                listTitle: "Elenco Agenti",
                noAgents: "Nessun agente da mostrare.",
                type: "Tipo",
                user: "Utente",
                active: "Attivo",
                achievements: "Risultati",
                select: "Seleziona",
                yes: "Sì",
                no: "No",
                view: "Vedi",
                exportCSV: "Esporta classifica agenti CSV",
                exportPDF: "Esportar PDF",
                createTestAgents: "Criar Agents de Prova",
                creating: "Creando...",
                viewDetails: "Ver detalhes do agente e seu rendimiento",
                editAgent: "Editar informações do agente",
                blockAgent: "Bloquear ou desativar agent",
                rankingTitle: "Classificação de Agentes",
                detailTitle: "Detalhe do Agente",
                tier: "Nível",
                associatedOpportunities: "Oportunidades associadas",
                operations: "Operações",
                opportunity: "Oportunidade",
                amount: "Montant",
                date: "Data",
                status: "Status",
                score: "Pontuação",
                feedback: "Comentário",
                fullProfile: "Perfil completo do agente",
                recentNotifications: "Notificações recentes",
                close: "Fechar",
                opportunities: "Opportunidades",
                commissions: "Comissões",
                actions: "Ações",
                all: "Todas",
            },
            admin: {
                goToAdminPanel: "Pannello di amministrazione",
                title: "Titolo",
                agent: "Agente",
                amount: "Montant",
                date: "Data",
                actions: "Azioni",
                viewAgent: "Vedi Agente",
                approve: "Approva",
                reject: "Rifiuta",
                agentDetails: "Dettagli dell'Agente",
                close: "Chiudi",
                rejectOpportunity: "Rifiuta Opportunità",
                rejectReason: "Motivo del rifiuto",
                cancel: "Annulla",
                opportunityApproved: "Oportunità approvata.",
                errorApproving: "Errore di approvazione dell'opportunità.",
                opportunityRejected: "Oportunità rifiutata.",
                errorRejecting: "Errore di rifiuto dell'opportunità.",
                noPendingOpportunities: "Nessuna opportunità in sospeso.",
            },
            header: { dashboard: "Cruscotto", logout: "Disconnettersi" },
            menu: {
                dashboard: "Cruscotto",
                opportunities: "Oportunités",
                investments: "Investimenti",
                portfolio: "Portafoglio",
                kyc: "Verificação KYC",
                financialVerification: "Verificação Financeira",
                offboarding: "Desboarding",
                adminPanel: "Painel de Administração",
                kycManagement: "Gestão KYC",
                offboardingManagement: "Gestão de Desboarding",
                agentes: "Agentes",
                collections: "Coleções",
                logout: "Sair",
                main: "Principal",
                tools: "Ferramentas",
                admin: "Administrador",
                preferences: "Preferências",
                messages: "Mensagens",
            },
            profile: {
                title: "My Profile",
                identity: "Identity & Account",
                investmentProfile: "Investment Profile",
                compliance: "Araudi Betetze eta Segurtasuna",
                preferences: "Preferences",
                name: "Name",
                email: "Email",
                phone: "Phone",
                kycStatus: "KYC Status",
                kycButton: "Submit/Update KYC",
                role: "Role",
                createdAt: "Account Created At",
                lastLogin: "Last Login",
                notAvailable: "Not available",
                portfolioValue: "Portfolio Value",
                numInvestments: "Number of Investments",
                riskLevel: "Preferred Risk Level",
                lastInvestment: "Last Investment Date",
                topOpportunities: "Top 3 Invested Opportunities",
                downloadData: "Download My Data (GDPR)",
                loginHistory: "Login History",
                language: "Language Preference",
                darkMode: "Dark Mode",
                notifications: "Notification Preferences",
                emailAlerts: "Email alerts (opportunity updates)",
                investmentUpdates: "Investment status updates",
                monthlySummary: "Monthly portfolio summary",
                consent: "Consent for Communications",
                consentSaved: "Consent updated successfully!",
                consentError: "Failed to update consent.",
                opportunityName: "Opportunity Name",
                opportunityCode: "Opportunity Code",
                investedAmount: "Invested Amount",
                expectedReturn: "Expected Return (%)",
                estimatedReturn: "Estimated Return",
                exportFileName: "mie_opportunita",
            },
            opportunity: {
                title: "Title",
                description: "Description",
                propertyType: "Property Type",
                location: "Location",
                totalBudget: "Total Budget (€)",
                expectedReturn: "Expected Return (%)",
                executionTime: "Execution Time (months)",
                minimumInvestment: "Minimum Investment (€)",
                projectImages: "Project Images",
                uploadImages: "Upload Images",
                legalDocumentation: "Legal Documentation",
                uploadDocuments: "Upload Documents",
                minCharacters: "minimum characters",
                minBudget: "Minimum €100,000",
                returnRange: "Between 5% and 50%",
                executionRange: "Between 6 and 120 months",
                submittedForApproval: "Opportunity submitted for approval",
                creationError: "Error creating opportunity",
                editProject: "Edit Project",
                createNewProject: "Create New Project",
                createProject: "Create Project",
            },
            common: {
                cancel: "Cancel",
                back: "Back",
                next: "Next",
                processing: "Processing...",
                update: "Update",
            },
        },
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n; 